import { jflApi } from "../../common/authApi";

// An admin's access is every store, whatever its `stores` list happens to hold,
// so the role decides the answer rather than the list. One helper, because the
// table and the form both have to agree on it.
export const ADMIN_ROLE = "admin";

export const isAdminRole = (roleName) =>
  (roleName || "").toLowerCase() === ADMIN_ROLE;

// GET /v1/users - every registered user. Kept out of redux on purpose: the
// store is persisted to localforage and this list is only needed while the
// Users page is open, so the page holds it in local state instead.
export const fetchUsers = async () => {
  try {
    const response = await jflApi.get("/v1/users");

    return { success: true, data: response.data?.data?.users ?? [] };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.error?.errorMessage ||
        error.response?.data?.message ||
        error.message ||
        "Could not load users",
    };
  }
};

// POST /v1/users. `stores` is a list of store CODES (DPI67209), not the store
// ids that GET /v1/users returns. The server owns validation - password must be
// at least 8 characters, and an unknown role or store code is rejected - so its
// message is passed straight back to the form.
export const createUser = async ({
  emailAddress,
  password,
  firstName,
  lastName,
  phoneNumber,
  roleName,
  stores,
}) => {
  try {
    const response = await jflApi.post("/v1/users", {
      emailAddress,
      password,
      firstName,
      lastName,
      phoneNumber,
      roleName,
      stores,
    });

    return { success: true, data: response.data?.data ?? null };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.error?.errorMessage ||
        error.response?.data?.message ||
        error.message ||
        "Could not register user",
    };
  }
};

// PATCH /v1/users/{userId}. Only these five fields: the server rejects
// emailAddress and password outright ("cannot be changed here"), so they are
// never sent. `stores` is codes, as with createUser.
export const updateUser = async (
  userId,
  { firstName, lastName, phoneNumber, roleName, stores }
) => {
  try {
    const response = await jflApi.patch(
      `/v1/users/${encodeURIComponent(userId)}`,
      { firstName, lastName, phoneNumber, roleName, stores }
    );

    return { success: true, data: response.data?.data ?? null };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.error?.errorMessage ||
        error.response?.data?.message ||
        error.message ||
        "Could not update user",
    };
  }
};
